module.exports = __webpack_public_path__ + "static/media/min-k-15.d49eabf0.png";